import axios from "axios";
const token = localStorage.getItem('authToken')
if(token){
    axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
}
export default {
    getMenuParts() {
        return axios.get(`/menu_parts`);
    },
    postMenuPart(obj) {
        return axios.post(`/menu_parts`, obj);
    },
    putMenuPart(id, obj) {
        return axios.put(`/menu_parts/${id}`, obj);
    },
    deleteMenuPart(id) {
        return axios.delete(`/menu_parts/${id}`);
    }
};
